<template>
  <div class="row">
    <div class="large-8 columns content__column">
      <h1>Endre passord</h1>
      <br>
      <div v-if="failed" class="form__errors">
            Det oppstod en feil
            <br>
            <br>
      </div>
      <div v-if="invalidToken">
            Linken for å endre passord kan bare brukes en gang eller har blitt for gammel.<br>
            <br>
            <router-link :to="{ name: 'RecoverPassword' }">Send meg ny link</router-link>.
            <br>
      </div>
      <div v-if="success">
        <br>
        Ditt passord er endret.<br>
        <br>
        <a href="/">Logg inn</a>
        <br>
      </div>
      <div v-if="!success && !invalidToken" class="row form">
        <div class="form__field small-12 medium-7 columns">
            <label class="form__label">
            Nytt passord <span class="form__required">*</span>
            <input type="password" name="password" maxlength="255" required autofocus v-model="password" v-validate="'min:6'" data-vv-as="passord">
            <span v-show="errors.has('password')" class="form__field__error">{{ errors.first('password') }}</span>
            </label>
        </div>
        <div class="form__submit small-12 large-7 columns">
            <button @click.prevent="changePassword" class="button form__submit__button">Send</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data () {
        return {
            password: '',
            success: false,
            failed: false,
            invalidToken:false,
        }
    },
    created() {
        var _this = this;
        this.$auth.ready(function () {
        });
    },
    methods: {
        getToken() {
            var variable = "token";
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i=0;i<vars.length;i++) {
                var pair = vars[i].split("=");
                if(pair[0] == variable){
                    return pair[1];
                }
            }
            return null;
        },

        changePassword(){
            var _this = this
            this.$validator.validateAll().then(isValid => {
                if(isValid) {
                    // reset
                    _this.failed = false;
                    _this.success = false;

                    // post
                    _this.$http({ method: 'post',url: '/caller/password/change', data: { token : _this.getToken(), password: _this.password } })
                        .then(function (response) {

                            // success
                            if(response && response.data) {
                                if(response.data.status == "success")
                                    _this.success = true;
                                else if(response.data.status == "invalidToken")
                                    _this.invalidToken = true;
                                else
                                    _this.failed = true;
                                // (response.data);
                            }

                        })
                        // failed
                        .catch(function (error) {
                            // console.log(error.response);
                            _this.failed = true;
                            if(error.response && error.response.data) {
                                var data = error.response.data;
                                // if(data.errors) {
                                //     console.log(data.errors);
                                // }
                            }
                        });
                    }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue